import React from 'react';
import './phoneNumberInput.css'; // Import the custom CSS file

interface PhoneNumberInputProps {
  label: string;
  name: string;
  value: string;
  placeholder?: string;
  tabIndex: number;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const PhoneNumberInput: React.FC<PhoneNumberInputProps> = ({ label, name, value, placeholder, tabIndex, onChange }) => {
  const handleIconClick = () => {
    if (value) {
      // Open the caller with the phone number if available
      window.open(`tel:${value}`);
    }
  };

  return (
    <div className="mb-3">
      <label className="form-label">{label}</label>
      <div className="input-group">
        <div className="input-group-prepend">
          <span className="rounded-0 rounded-start input-group-text" onClick={handleIconClick} style={{ cursor: 'pointer' }}>
            <i className="bi-telephone-fill phone-icon"></i>
          </span>
        </div>
        <input
          type="tel"
          className="form-control no-spinner"
          placeholder={placeholder || label}
          name={name}
          value={value}
          onChange={onChange}
          tabIndex={tabIndex}
          pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}" // Example pattern for US phone number
        />
      </div>
    </div>
  );
};


export default PhoneNumberInput;
